import { v4 as uuidV4 } from 'uuid'
import AppLog from '@/services/errors/app-logs'
import AppWarn from '@/services/errors/app-warns'
import { constantStrings } from '@/services/constants'
import { cookieConstant, eventType } from '../../services/constants'
import { getCookie } from '../../services/cookie'
import {emitEventToParentWindow} from '../../services/utils'
export default {
  updateFallbackMechanismState({commit}, data) {
    commit('UPDATE_FALLBACK_MECHANISM_STATE', data)
  },

  removeLastFallbackRetryMessage({ commit, rootState }) {
    commit('DELETE_CHAT_AT_ITH_POS', rootState.chats.length - 1)
  },

  clearFallbackMechanismTimer({ dispatch, rootState }) {
    const timerId = rootState.fallbackMechanismState.retryTimerId
    if (timerId) {
      clearTimeout(timerId)
      dispatch('updateFallbackMechanismState', { isVisible: false, retryTimerId: '', message: '', quickReplies: '' })
    }
  },

  throttleFallbackMechanism({ dispatch, rootState, getters }, data) {
    try {
      if (!getters.isFallbackMechanismEnabled || ((data?.hide || data?.userMessage?.hideMessage) && (!data.isRetryMessage && !data.userMessage.isStreaming))) {
        return
      }
      dispatch('clearFallbackMechanismTimer')
      const timerId = setTimeout(() => {
        const messageToTrigger = data.userMessage?.payload || ''
        dispatch('addFallbackRetryMechanismInChats', { messageToTrigger, timestamp: data?.timestamp })
        if (rootState.fallbackMechanismState.retryLeft > 0) {
          dispatch('addQuickRepliesInFallbackRetryMechanism')
        }
        data.userMessage?.isStreaming && dispatch('deleteChatAtIthPosition', rootState.chats.length - 2)
        new AppLog({
          name: 'Fallback Retry Mechanism',
          message: `Fallback Retry Mechanism triggered by the message: ${JSON.stringify(data)}`,
          logLevel: 'info',
          service: 'Action'
        })
        getters.isPromptTestingEnable && emitEventToParentWindow(eventType.MESSAGE_ERROR,{conversationId : getCookie(cookieConstant.SESSION.CONVERSATION_ID), messageId: data?.userMessage?.messageValue?.messageId})
      }, getters.getFallbackMechanismDuration * 1000)

      const currentRetryLeft = rootState.fallbackMechanismState.retryLeft
      const retryLeft = data.isRetryMessage ? currentRetryLeft - 1 : data.userMessage?.isStreaming ? currentRetryLeft : getters.getFallbackMechanismMaxRetry
      dispatch('updateFallbackMechanismState', { isVisible: false, retryTimerId: timerId, retryLeft })
    } catch (error) {
      console.log(error)
      new AppWarn({
        name: 'Action',
        message:`Error while sending retry message: ${error.message}`
      })
    }
  },

  addFallbackRetryMechanismInChats({ dispatch, getters }, { messageToTrigger, timestamp }) {
    const message = dispatch('addFallbackResponseInChats', { text: getters.getFallbackMechanismMessage, messageToTrigger, timestamp })
    dispatch('updateFallbackMechanismState', { isVisible: true, message })
  },

  addQuickRepliesInFallbackRetryMechanism({ dispatch, getters }) {
    const quickReplies = getters.getFallbackMechanismActionButtons?.map(({ label, payload }) => {
      return {
        label,
        metadata: payload,
        description: label,
        contentType: constantStrings.TEXT
      }
    })
    dispatch('updateQuickReplyOptions', quickReplies)
    dispatch('updateFallbackMechanismState', { quickReplies })
  },

  addFallbackResponseInChats({ commit }, { text, messageToTrigger, timestamp, hideRetry }) {
    const message = retryMessageFormatter(
      {
        text,
        messageToTrigger,
        hideRetry,
        timestamp: timestamp || Date.now()
      }
    )
    commit('UPDATE_CHATS', message)
    return message
  }
}

const retryMessageFormatter = ({ text, messageToTrigger, hideRetry, timestamp }) => {
  return {
    isUser: false,
    hide: false,
    messages:[{
      messageId: uuidV4(),
      type: "FallbackMechanism",
      isUser: false,
      messageValue: {
        text,
        messageToTrigger,
        hideRetry
      },
      timestamp
    }]
  }
}
